/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import TranslateIcon from "@material-ui/icons/Translate";

import { Button, Grid } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import i18next from "i18next";

import {
  Container,
  ContainerTranslateButton,
  FormContent,
} from "./Auth.styles";
import Footer from "./components/Footer/Footer";
import LoginForm from "./components/LoginForm/LoginForm";

const languageMap: Record<string, string> = {
  en: "EN",
  es: "ES",
  it: "ITA",
  pt: "PT",
};

export default function Login() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentLanguage, setCurrentLanguage] = React.useState(
    i18next.language
  );

  const getApiLanguageCode = (lng: string) => {
    return languageMap[lng] || "EN"; 
  };

  const changeLanguage = (lng: string) => {
    i18next.changeLanguage(lng);
    setCurrentLanguage(lng);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickLanguage = (language: string) => {
    changeLanguage(language);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container>
      <ContainerTranslateButton>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <TranslateIcon />
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => handleClickLanguage("en")}>English</MenuItem>
          <MenuItem onClick={() => handleClickLanguage("es")}>Español</MenuItem>
          <MenuItem onClick={() => handleClickLanguage("it")}>
            Italiano
          </MenuItem>
          <MenuItem onClick={() => handleClickLanguage("pt")}>
            Português
          </MenuItem>
        </Menu>
      </ContainerTranslateButton>
      <FormContent>
        <Grid>
          <LoginForm selectedLanguage={getApiLanguageCode(currentLanguage)} />
        </Grid>
      </FormContent>
      <Footer />
    </Container>
  );
}
